import { Grid } from "@mui/material";
import React from "react";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import {
  callAPI,
  IRoleMain,
  MasterPages,
  Method
} from "../../commonFunctions/CommonFunctions";
import { Header, IHeaderActions } from "../../Components/Header/Header";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";

const EmployeeList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  // const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);

  const [isPopupOpen, setPopupOpen] = React.useState(false); //for delete;
  const [selectedIdForDlt, setSelectedIdForDlt] = React.useState<any>(null);

  const source = {
    url: "employees/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  //edit / delete or perform other actions.
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/employee/${row?._id}`);
    } else if (action === "Delete") {
      setPopupOpen(true);
      setSelectedIdForDlt(row?._id);
    }
  };

  const handleDelete = () => {
    dispatch(resetDataComponent("employeeGrid"));
    showMessage("Employee deleted successfully!", "success");
  };

  const handleClick = () => {
    navigate('/employee')
  };

  const columns: IColumns[] = [
  {
    header: "Name",
    fieldName: "fullName", // You can either split fname + lname or combine server-side
    tooltip: true,
    sortable: true
  },
  {
    header: "Code",
    fieldName: "empCode",
    tooltip: true,
    sortable: true
  },
  {
    header: "Email",
    fieldName: "officialEmail",
    tooltip: true
  },
  {
    header: "Phone",
    fieldName: "mobileNumber",
    tooltip: true
  },
  {
    header: "Designation",
    fieldName: "designation",
    tooltip: true
  },
  {
    header: "CTC",
    fieldName: "ctc",
    tooltip: true,
    sortable: true,
  },
  {
    header: "Joined",
    fieldName: "dateOfJoining",
    tooltip: true,
    type: "date"
  },
  {
    header: "Status",
    fieldName: "status",
    tooltip: true
  },
  {
    header: "Actions",
    fieldName: "actions",
    type: "action",
    actions: ["Edit", "Delete"],
    actionCallback: (action, row) => handleAction(action, row)
  }
];


  const action: IHeaderActions = {
    type: "button",
    text: "+ New Employee",
    size: "medium",
    onClick: handleClick,
    variant: "contained",
    color: "primary",
    sx: {
      backgroundColor: "#FF6B2C",
      textTransform: "none",
      "&:hover": { backgroundColor: "#e65c1d" }
    }
  };

  return (
    <>
      <Helmet>
        <title>Employee | Willsoar Technologies</title>
        <meta
          name="description"
          content="Manage all your employees in one place. View, add, or edit employee information easily."
        />
      </Helmet>
      <Grid p={2}>
        <Header
          type="dashboard"
          title="Employee"
          id={"employeeHeader"}
          action={action}
        />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="employeeGrid"
              columns={columns}
              source={source}
              exportCsv
            />
          </Grid>
        </Grid>

         
        {isPopupOpen && (
          <ConfirmationPopup
            apiUrl={"employees/delete"}
            id={selectedIdForDlt}
            confirmMessage="Are you sure you want to delete this employee?"
            open={isPopupOpen}
            onClose={() => setPopupOpen(false)}
            onConfirm={handleDelete}
            permanent
          />
        )}
      </Grid>
    </>
  );
});

export default EmployeeList;